import _ from "lodash";

export const newAccountOpeningRoutes = {
    newAccount: "/new-account",
    entity: "/new-account/entity",
    confirmdetails: "/new-account/confirmdetails",
    confirmproduct: "/new-account/confirmproduct",
    kyc: "/new-account/kyc",
    confirmauthorisers: "/new-account/confirmauthorisers",
    confirmapplication: "/new-account/confirmapplication",
    custodyaccount: "/new-account/custodyaccount"
};

export const newBolProfileRoutes = {
    bol: "/bol",
    details: "/bol/details",
    channel: "/bol/channels",
    options: "/bol/options",
    accounts: "/bol/accounts",
    users: "/bol/users",
    complete: "/bol/complete"
};

export const businessOnlineRoutes = {
    businessOnline: "/business-online",
    transaction: "/business-online/transaction",
    accountSetup: "/business-online/accounts-setup",
    authorization: "/business-online/authorization",
    contactDetails: "/business-online/contact-details",
    complete: "/business-online/complete"
};

export const newCustodyAccountRoutes = {
    custodyaccount: "/custodyaccount",
    accountrelations: "/custodyaccount/accountrelations",
    beneficialowner: "/custodyaccount/beneficialowner",
    addressdetails: "/custodyaccount/addressdetails",
    contactdetails: "/custodyaccount/contactdetails",
    instructingparty: "/custodyaccount/instructingparty",
    complete: "/custodyaccount/complete",
    accountcashpurpose: "/custodyaccount/AccountcashpurposePage",
    confirmauthorisers: "/custodyaccount/confirmauthorisers",
}
const CHEQUE_PENDING_TASKS = {
    confirmEnitityDetails: "UserTask_ConfirmEnitityDetails",
    confirmAccountDetails: "UserTask_ConfirmAccountDetails",
    allConfirmed: "UserTask_AllConfirmed"
};

export const globalMarketAccountRoutes = {
    entity: "/globalmarket/entity",
    confirmentity: "/globalmarket/confirmentity",
    //customers: "/globalmarket/customers",
    instructions: "/globalmarket/instructions",
    complete: "/globalmarket/complete"
};

export const digitalCreditRoutes = {
    root: "/credit",
    details: "/credit/details",
    complete: "/credit/complete",
};

export const maintenanceRoutes = {
    root: '/maintenance',
};

export const kycRoutes = {
    root: '/kyc',
    review: '/kyc/review',
    complete: '/kyc/complete'
};

export const remediationRoutes = {
    root: '/EBTC',
    legals: '/EBTC/agreements',
    complete: '/EBTC/Complete'
};

export const tpfaRoutes = {
    root: '/TPFA',
    thirdParty: '/TPFA/TP-Details',
    complete: '/TPFA/Complete'
};


export const menuRoutes = {
    accountOpening: newAccountOpeningRoutes.newAccount,
    maintenance: maintenanceRoutes.root,
    newEntity: '/onboard',
    payments: '/payments',
    reporting: "/reporting",
    track: "/track",
    bol: "/bol",
    businessOnline: "/business-online",
    custody: "/custodyaccount",
    globalmarket: globalMarketAccountRoutes.entity,
    credit: digitalCreditRoutes.root,
    custodyaccount: newCustodyAccountRoutes.custodyaccount,
    kyc: kycRoutes.root,
    remediation: remediationRoutes.root,
    tpfa: tpfaRoutes.root
};



